export default "__VITE_ASSET__B3y4Ivvq__"